<template>
  <v-container fluid class="pad">
    <v-row justify="center">
      <v-col cols="12" sm="12" md="10">
        <router-view />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import helpers from '@/mixins/helpers';
export default {
  mixins:[helpers],
  created() {
    this.helpers;
  },
};
</script>

<style scoped>
.pad {
  padding: 20px;
}
</style>